export default __webpack_public_path__ + "static/media/banner-2.9205e881.png";